import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalCursoSaludPublica = ({ toggleFunction, modalState }) => {
  const formLink = 'https://forms.gle/Xa5q9PT7Fr4wD3kK9'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Curso Medio de Salud Pública</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container cupos-container cards-center text-center'>
          <p hidden className='heading-title fw-semibold mb-4'></p>

          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Fecha de Inicio</p>
            <p className='fw-normal'>02 de marzo de 2026</p>
          </div>
          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Modalidad</p>
            <p className='fw-normal spaced-sm'>Semipresencial</p>
            <p className='fw-normal'>Edificio Ciencia y Salud 2do Piso, Salón de Usos Múltiples</p>
          </div>

          <a className='btn btn-primary link-button mb-4' href={formLink} target='blank'>
            Formulario de Inscripción
          </a>

          <div className='info-group mt-3 mb-1'>
            <p className='fw-semibold mb-0'>Dr. Freddy Pachano Arenas</p>
            <p className='fw-semibold mb-3'>Director</p>

            <p className='fw-semibold mb-0'>Dra. Noris Acosta</p>
            <p className='fw-semibold mb-0'>Coordinadora</p>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalCursoSaludPublica }